import styled from 'styled-components'
import ContextMenuBase from 'widgets/context-menu/flat'

export const ContextMenu = styled(ContextMenuBase)`
    overflow: hidden;

    border: 1px solid var(--huma-color-border-default);
    border-radius: 8px;
`